"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFIXES = exports.PREFIX_DEFAULT = void 0;

var _networks = require("@polkadot/networks"); // Copyright 2017-2020 @polkadot/ui-settings authors & contributors
// SPDX-License-Identifier: Apache-2.0


var PREFIX_DEFAULT = -1;
exports.PREFIX_DEFAULT = PREFIX_DEFAULT;
var defaultNetwork = {
  info: 'default',
  text: 'Default for the connected node',
  value: -1
};

var networks = _networks.available.map(function (_ref) {
  var displayName = _ref.displayName,
      network = _ref.network,
      prefix = _ref.prefix;
  return {
    info: network,
    text: displayName,
    value: prefix
  };
});

var PREFIXES = [defaultNetwork].concat(_toConsumableArray(networks));
exports.PREFIXES = PREFIXES;